module.exports = __webpack_public_path__ + "img/w3_add_white.e8a843a4.png";